import { Button, Result, message } from "antd";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const UnAuthority = () => {
  const navigate = useNavigate();
  useEffect(() => {
    console.log("您无此菜单权限，请向超级管理员申请");
    message.error("您无此菜单权限，请向超级管理员申请！");
  }, []);
  return (
    <Result
      status="403"
      title="403"
      subTitle="抱歉，你无权访问该页面。请联系超级管理员添加权限"
      extra={
        <Button type="primary" onClick={() => navigate(-2)}>
          返回
        </Button>
      }
    />
  );
};

export default UnAuthority;
